import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src3800784703/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
